// extracted by mini-css-extract-plugin
export default {"campaignInput":"CampaignFormSkeleton_campaignInput__KLkIM","actions":"CampaignFormSkeleton_actions__gMqKe"};